import { faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import DwvComponent from '../DcmViewer';
import { DcmViewerHook } from '../DcmViewer.hook';
import DicomViewer from '../DicomViewer';

import "./DicomViewModal.css";
import CornerStoneDicomViewer from '../CornerStoneDicomViewer';

interface IDicomViewModal {
  show: boolean
  setShow: any
  links: any
  statement: string;
}


export default function DicomViewModal(props: IDicomViewModal) {
  
  useEffect(() => {
    if (props.statement) {
        const element = document.getElementById("dcm-statement-text-question");
        if (element) {
            element.innerHTML = props.statement
        }
    }
}, [props.statement])

  return (
    <>
      <Modal show={props.show} fullscreen={true} onHide={() => props.setShow(false)} className='dicom-modal-fullscreen-single'>
        <Modal.Title className="text-white m-3"><FontAwesomeIcon icon={faClose} onClick={() => props.setShow(false)} className="me-3 dcm-link-cursor" /> Dicom Control View</Modal.Title>
        <Modal.Body>
          {/* <DcmViewerHook
            dicomData={props.dicomData}
            onClose={() => props.setShow(false)}
            controlId="layer_group_modal_dicom"
          /> */}
          <p className='text-white fs-3' id="dcm-statement-text-question" dangerouslySetInnerHTML={{__html: props.statement}}></p>
          <CornerStoneDicomViewer onClose={() => props.setShow(false)} links={props.links} show={props.show} />
        </Modal.Body>
      </Modal>
    </>
  );
}